import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Global per-device UI settings
 * @see https://github.com/pmndrs/zustand/blob/main/docs/integrations/persisting-store-data.md
 */

export const useDeviceUISettings = create(
  persist<{
    tagsFilter: string[]
    setTagsFilter: (tagsFilter: string[]) => void
  }>(
    set => ({
      tagsFilter: [],
      setTagsFilter(tagsFilter: string[]) {
        set({ tagsFilter })
      },
    }),
    {
      name: 'tunasong.editor-ui',
    }
  )
)
